<template>
  <el-form ref="detailForm" :model="detail" label-width="100px" :label-position="device === 'mobile' ? 'top' : 'right'">
    <el-collapse v-model="activeCollapses" class="el-card-collapse">
      <el-collapse-item title="基本信息" name="Basic">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="16">
            <el-form-item label="商品名称">
              <span class="el-input">{{ detail.goodsName }}</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item class="inline-form-item" label="商品单位">
              <span class="el-input max-width">{{ detail.goodsUnit }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="商品图片" prop="cover">
              <el-image :src="detail.cover" lazy />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="16">
            <el-form-item label="商品轮播图">
              <div class="image-list">
                <el-image v-for="(item, index) in detail.galleries" :key="index" :src="item" lazy />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>

      <el-collapse-item title="商品价格" name="Prices">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="供货价">
              <span class="el-input max-width">{{ detail.stockPrice }}</span>
              <el-tooltip effect="light" content="供货价包含了快递费用等" placement="right"><i class="el-icon-warning-outline" /></el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item class="inline-form-item" label="建议售价">
              <span class="el-input max-width">{{ detail.retailPrice }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>

      <el-collapse-item title="商品介绍" name="Introduction">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item>
              <div class="my-editor" v-html="detail.intro" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      activeCollapses: ['Basic', 'Prices', 'Introduction']
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  }
}
</script>

<style lang="scss" scoped>
.el-form-item .el-icon-warning-outline {
  margin-left: 8px;
  font-size: 18px;
  color: #e6a23c;
}
span.el-input {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}
.my-editor {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  line-height: 1;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 10px;
  white-space: pre-wrap;
  box-sizing: border-box;
  ::v-deep img {
    width: 100%;
    height: auto;
    max-width: 750px;
  }
}
.mobile {
  .el-image {
    width: 138px;
    height: 138px;
  }
  .inline-form-item ::v-deep {
    .el-form-item__label {
      width: 85px;
    }
    .max-width {
      max-width: 100%;
    }
  }
}
.el-image {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  width: 148px;
  height: 148px;
}
.image-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 8px 8px 0;
  }
}
</style>
